import { render, staticRenderFns } from "./jxyPlay.vue?vue&type=template&id=27c1b963"
import script from "./jxyPlay.vue?vue&type=script&lang=js"
export * from "./jxyPlay.vue?vue&type=script&lang=js"
import style0 from "./jxyPlay.vue?vue&type=style&index=0&id=27c1b963&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports